"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./index.css");
const canvaskit_1 = require("./canvaskit");
const fonts_1 = require("./fonts");
const dataflow_1 = require("./dataflow");
(0, fonts_1.preloadFonts)();
(0, canvaskit_1.CanvasKitInit)().then(dataflow_1.ignite);
